// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState, useContext, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import MemberContext from '../../contexts/MemberContext';
import MainLayout from '../../layouts/MainLayout';
import ProductCardList from './components/ProductCardList';
import HistoryTable, { ProductHistoryRow } from './components/HistoryTable';
import HandsOnHistoryTable from './components/HandsOnHistoryTable';
import ReviewHistoryTable from './components/ReviewHistoryTable';
import { S } from './styles';
import { WebSocketContext } from '../../contexts/WebSocketContext';
import homeSelector from '../../redux/selectors/homeSelector';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { ProductCard } from '../../components/NewCard/types';
import { FormattedMessage } from 'react-intl';
import PopUpInfo from './components/PopUpInfo';
import CourseFilter from './components/CourseFilter';

const { getHomeActions } = actionCreatorsList;

enum TabType {
  MyCourses = 'B002',
  History = 'B003',
  ReviewHistory = 'B053',
  HandsOnHistory = 'B045',
}

enum NoReviewTabType {
  MyCourses = 'B002',
  History = 'B003',
  HandsOnHistory = 'B045',
}

const courseType = [{
  key: 'workshop',
  message: 'B004'
}, {
  key: 'onlineCourse',
  message: 'B005'
}, {
  key: 'iltCourse',
  message: 'B063'
}]

function useWebsocketMessage(handler: (message: any) => void) {
  const websocket = useContext(WebSocketContext);

  useEffect(() => {
    websocket?.websocket?.addEventListener('message', handler);

    return () => {
      websocket?.websocket?.removeEventListener('message', handler);
    }
  }, [websocket, handler]);
}

function useGetHome() {
  const dispatch = useDispatch();

  const getHome = useCallback(() => {
    dispatch(getHomeActions.request({}));
  }, [])

  return getHome;
}

function HomePage ():JSX.Element {
  const member = useContext(MemberContext);
  const loading = useSelector(homeSelector.makeHomeIsFetching());
  const myCourseList: ProductCard[] = useSelector(homeSelector.makeHomeMyCourse());
  const [courseList, setCourseList] = useState(myCourseList);
  const historyList: ProductHistoryRow[] = useSelector(homeSelector.makeHomeHistory());
  const [currentTab, setShowingTab] = useState<TabType>(TabType.MyCourses);
  const [handsOnType, setHandsOnType] = useState<string>('lab');
  const [clickSubmit, setClickSubmit] = useState(false);
  const [currentType, setCurrentType] = useState<string>('All');
  const getHome = useGetHome();
  const history = useHistory();
  const error = useSelector(homeSelector.makeError());

  const getHomeInfoRemindCheck = () => {
    const remindCheck = localStorage.getItem('homeInfoRemind');
    return remindCheck && remindCheck === 'true' ? true : false;
  }

  const updateDisplayList = () => {
    if (currentType !== 'All') {
      const filterList = myCourseList.filter((course) => course.type === currentType);
      setCourseList(filterList);
    } else {
      setCourseList(myCourseList);
    }
  }

  useWebsocketMessage((message) => {
    if (message.data == 'home') {
      getHome();
    }
  })

  useEffect(() => {
    getHome();
  }, []);

  useEffect(() => {
    if (history?.location?.state) {
      setShowingTab(TabType.HandsOnHistory);
      setHandsOnType('exam');
    }
  }, [history?.location?.state]);

  useEffect(() => {
    if (!member.isBifrostLogin) {
      setClickSubmit(true);
    } else {
      setClickSubmit(false);
    }
  }, [member.isBifrostLogin]);

  useEffect(() => {
    updateDisplayList();
  }, [loading, currentType])

  const renderContent = (currentTab: TabType) => {
    if (currentTab === TabType.MyCourses && myCourseList.length > 0 && courseList.length > 0) {
      return (
        <S.CourseContainer>
          <ProductCardList list={loading ? myCourseList : courseList} />
        </S.CourseContainer>
      )
    } else if (currentTab === TabType.History && historyList.length > 0) {
      return (
        <S.HistoryContainer>
          <HistoryTable list={historyList} />
        </S.HistoryContainer>
      )
    } else if (currentTab === TabType.HandsOnHistory) {
      return (
        <S.HistoryContainer>
          <HandsOnHistoryTable handsOnType={handsOnType}/>
        </S.HistoryContainer>
      )
    } else if (currentTab === TabType.ReviewHistory) {
      return (
        <S.HistoryContainer>
          <ReviewHistoryTable />
        </S.HistoryContainer>
      )
    } else if (currentTab === TabType.MyCourses) {
      return (
        <S.NoDataWrapper>
          <S.EmptyHomeIcon />
          <S.EmptyHomeText><FormattedMessage id="B027"/></S.EmptyHomeText>
          <S.EmptyHomeLink as={Link} to="/onlineCourses"><FormattedMessage id="B028"/></S.EmptyHomeLink>
        </S.NoDataWrapper>
      )
    } else if (currentTab === TabType.History) {
      return (
        <S.NoDataWrapper>
          <S.EmptyHomeIcon />
          <S.EmptyHomeText><FormattedMessage id="B029" values={{ br: <br/> }} /></S.EmptyHomeText>
          <S.EmptyHomeLink onClick={() => setShowingTab(TabType.MyCourses)}><FormattedMessage id="B030"/></S.EmptyHomeLink>
        </S.NoDataWrapper>
      )
    }
  }

  if (error) {
    console.log({ error })
    return (
      <MainLayout>
        <S.ErrorPage />
      </MainLayout>
    )
  }

  if (loading) {
    return (
      <MainLayout>
        <S.LoadingWrapper>
          <S.LoadingAnimation />
        </S.LoadingWrapper>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <S.Banner>
        <S.BannerContainer>
          <S.TitleContainer>
            <S.Title><FormattedMessage id="B001" values={{ username: member.username }} /></S.Title>
            <CourseFilter
              type={currentType} updateType={setCurrentType} typeList={courseType}
            />
          </S.TitleContainer>
          <S.Tab tabs={member.isReviewer ? Object.values(TabType) : Object.values(NoReviewTabType)} currentTab={currentTab} handleChangeTab={(tab: string) => setShowingTab(tab as TabType)} handsOnType={handsOnType} setHandsOnType={setHandsOnType}/>
        </S.BannerContainer>
      </S.Banner>
      {renderContent(currentTab)}
      { clickSubmit && !getHomeInfoRemindCheck() ? <PopUpInfo setClickSubmit={setClickSubmit}/> : null }
    </MainLayout>
  );
}

export { HomePage as default }
